import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { installChunkReload } from './lib/chunk-reload'
import 'maplibre-gl/dist/maplibre-gl.css'
import './styles/index.css'

// Recover from stale dynamic-import chunks after a deploy (blank page on
// lazy-route navigation) by reloading to the fresh shell. Install before
// render so the listeners are live for the first navigation.
installChunkReload()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
